export const NODATA_MESSAGES = {
    NO_USERS: 'No user data.',
    NO_USER_ACTIVITIES: 'No user activity data.',
    NO_DEVICES: 'No device data.',
    NO_ORGANIZATIONS: 'No organization data.',
    NO_ADMINISTRATORS: 'No administrator data.',
    NO_ROLES_AND_PERMISSIONS: 'No role and permissions data.',
    NO_ACTIVITY_LOGS: 'No activity log data.',
    NO_THREAT_PAIRS: 'No threat pair data.',
    NO_WATCH_THEMES: 'No watch theme data.'
}